import { render } from "./PartnerVideos.vue?vue&type=template&id=7b85a0d8&scoped=true"
import script from "./PartnerVideos.vue?vue&type=script&lang=js"
export * from "./PartnerVideos.vue?vue&type=script&lang=js"

import "./PartnerVideos.vue?vue&type=style&index=0&id=7b85a0d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b85a0d8"]])

export default __exports__